import { OPTIONAL_FACE_KEYS, type OptionalFaceKey } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useStore } from 'zustand';
import { usePhotoDraftStore } from '@/entities/edit-area';
import { FACE_LABELS } from '../model/face-labels';

interface PhotoFaceOptionsProps {
  readonly onBeforeRemoval?: (face: OptionalFaceKey) => boolean;
  readonly managed?: boolean;
}

export const PhotoFaceOptions = ({
  onBeforeRemoval,
  managed = false,
}: PhotoFaceOptionsProps): ReactElement => {
  const store = usePhotoDraftStore();
  const state = useStore(store);
  return (
    <fieldset className="space-y-2 rounded border p-3">
      <legend className="px-1 font-medium">선택 면 사용 (모든 색상 공통)</legend>
      <div className="flex flex-wrap gap-4">
        {OPTIONAL_FACE_KEYS.map((face) => (
          <label key={face} className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={state.draft.activeFaces.includes(face)}
              disabled={state.lockedFaces.includes(face)}
              onChange={(event) => {
                if (!event.target.checked && onBeforeRemoval && !onBeforeRemoval(face)) return;
                state.setOptionalFaceEnabled(face, event.target.checked);
              }}
            />
            {FACE_LABELS[face]} 사용
          </label>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        {managed
          ? '앞면은 늘 씁니다. 사용하는 면은 모든 색상에 사진이 필요하고, 한 면만 인쇄하는 상품은 뒷면을 꺼 둡니다. 면을 제거하면 해당 사진 참조·표면·배치가 함께 제거됩니다.'
          : '앞면은 늘 씁니다. 사용하는 면은 모든 색상에 사진이 필요합니다. 기존 편집 영역이 사용하는 면의 제거는 편집영역 설정 화면에서 진행합니다.'}
      </p>
    </fieldset>
  );
};
